module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("This book would not exist but for the unstinting efforts of Steven J. Anzalone, my brother and keeper; Walker Kornfeld, my editor and literary surgeon; and Craig Carda, enabler to us all.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0